import Icon from './Icon';

const CopyToClipboard = (props) => (
  <Icon
    {...props}
    path="M7.5 16.667v26.667c0 5.063 4.104 9.167 9.167 9.167h5.833v-5h-5.833c-2.301 0-4.167-1.865-4.167-4.167v-26.667c0-2.301 1.865-4.167 4.167-4.167h26.667c2.301 0 4.167 1.865 4.167 4.167v5.833h5v-5.833c0-5.063-4.104-9.167-9.167-9.167h-26.667c-5.063 0-9.167 4.104-9.167 9.167zM47.5 27.5h15.833c5.063 0 9.167 4.104 9.167 9.167v26.667c0 5.063-4.104 9.167-9.167 9.167h-26.667c-5.063 0-9.167-4.104-9.167-9.167v-26.667c0-5.063 4.104-9.167 9.167-9.167h10.833zM52.5 32.5h-15.833c-2.301 0-4.167 1.865-4.167 4.167v26.667c0 2.301 1.865 4.167 4.167 4.167h26.667c2.301 0 4.167-1.865 4.167-4.167v-26.667c0-2.301-1.865-4.167-4.167-4.167h-10.833zM52.5 43.333v-5.833h-5v5.833c0 2.301-1.865 4.167-4.167 4.167h-5.833v5h5.833c5.063 0 9.167-4.104 9.167-9.167z"
  />
);

export default CopyToClipboard;
